(() => {
  const config = JSON.parse(document.getElementById('BusinessBrandNavigation').textContent);
  if (!config.business && !document.documentElement.hasAttribute('data-business-brand')) return;

  const withoutLocale = path => path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:pages|blogs)\/)/, '').replace(/\/$/, '');
  const canonicalPaths = [
    '/pages/our-story-safeguarding-the-craft',
    '/blogs/atelier-notes/rempliage-the-folded-edge',
    '/blogs/curated-knowledge/how-fes-forged-the-meaning-of-luxury-and-why-the-world-forgot',
    '/pages/the-lunburg-artisan-fund'
  ];
  const targets = new Set([...canonicalPaths, ...config.paths].map(withoutLocale));
  for (const link of document.querySelectorAll('a[href]')) {
    const url = new URL(link.href);
    if (url.origin !== location.origin || !targets.has(withoutLocale(url.pathname))) continue;
    url.searchParams.set('business', '1');
    link.href = url.pathname + url.search + url.hash;
  }

  // Shopify localization forms must retain the explicit presentation on return.
  if (document.documentElement.hasAttribute('data-business-brand')) {
    for (const button of document.querySelectorAll('button[name="locale_code"]')) {
      button.addEventListener('click', event => {
        event.preventDefault();
        const root = config.languages[button.value].replace(/\/$/, '');
        location.assign(root + withoutLocale(location.pathname) + location.search + location.hash);
      });
    }
    for (const form of document.querySelectorAll('form[action*="/localization"]')) {
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      });
    }
  }
})();
